import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { supabase } from '@/lib/supabase';

/** Premier accès : le compte n'est rattaché à aucun cabinet → création (l'utilisateur en devient administrateur). */
export function CreerCabinet({ email }: { email?: string }) {
  const qc = useQueryClient();
  const [nom, setNom] = useState('');
  const [envoi, setEnvoi] = useState(false);
  const [code, setCode] = useState('');
  return (
    <div className="flex min-h-[70vh] items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Créer votre cabinet</CardTitle>
          <CardDescription>
            Le compte {email} n'est encore rattaché à aucun cabinet. Créez-le : vous en serez administrateur et pourrez ensuite inviter vos experts.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form className="space-y-3" onSubmit={async (e) => {
            e.preventDefault();
            setEnvoi(true);
            const { error } = await supabase.rpc('creer_cabinet', { p_nom: nom.trim() });
            setEnvoi(false);
            if (error) return toast.error(`Création impossible : ${error.message}`);
            toast.success('Cabinet créé');
            await qc.invalidateQueries();
          }}>
            <div className="space-y-1.5">
              <Label htmlFor="nom-cabinet">Nom du cabinet</Label>
              <Input id="nom-cabinet" required minLength={2} value={nom} onChange={(e) => setNom(e.target.value)} placeholder="ex. Cabinet Caron Expertises" />
            </div>
            <Button type="submit" className="w-full" disabled={envoi || nom.trim().length < 2}>Créer le cabinet</Button>
          </form>
          <form className="mt-6 space-y-3 border-t pt-4" onSubmit={async (e) => {
            e.preventDefault();
            setEnvoi(true);
            const { error } = await supabase.rpc('accepter_invitation', { p_token: code.trim() });
            setEnvoi(false);
            if (error) return toast.error(error.message);
            toast.success('Bienvenue dans le cabinet');
            await qc.invalidateQueries();
          }}>
            <Label htmlFor="code-invitation">Ou rejoindre un cabinet existant avec le code reçu de l'administrateur</Label>
            <div className="flex gap-2">
              <Input id="code-invitation" value={code} onChange={(e) => setCode(e.target.value)} placeholder="Code d'invitation" />
              <Button type="submit" variant="outline" disabled={envoi || code.trim().length < 10}>Rejoindre</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
